import { Ref } from 'vue';
import { useI18n } from 'vue-i18n';
import useVeFlakeApprovals from '@/composables/farm/useVeFlakeApprovals';
import { TransactionActionInfo } from '@/types/transactions';

export default function useVeFlakeApprovalActions(
  tokenAddresses: string[],
  amounts: Ref<string[]>
) {
  const { t } = useI18n();
  const { requiredApprovalState, approveToken } = useVeFlakeApprovals(
    tokenAddresses,
    amounts
  );

  const tokenApprovalActions: TransactionActionInfo[] = Object.keys(
    requiredApprovalState.value
  ).map(address => {
    return {
      label: 'Approve veFlake for staking',
      loadingLabel: t('investment.preview.loadingLabel.approval'),
      confirmingLabel: t('confirming'),
      stepTooltip:
        'You must approve veFlake to stake this token on Hexagon. Approvals are required once per token, per wallet.',
      action: () => {
        return approveToken(address);
      }
    };
  });

  return {
    tokenApprovalActions
  };
}
